import {ScriptDefinition} from "@common-core/react-composable/script-injector";
import {VisibleItem} from "../visibility";

export interface EmbeddedComponent extends VisibleItem {
  id: string;
  script: ScriptDefinition;
  element: string;
  attributes?: Record<string, any>;
  preload?: boolean;
}

export function isEmbeddedComponent(arg: any): arg is EmbeddedComponent {
  return (
    arg !== null &&
    arg !== undefined &&
    typeof arg.id === "string" &&
    typeof arg.element === "string" &&
    typeof arg.script === "object" &&
    arg.script !== null
  );
}
